import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { take } from 'rxjs/operators';
import { requestsService } from '../services/requests/requests.service';
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {

  signUpForm: FormGroup;
  showError: string = null;
  showSuccess = false;
  hidePassword:boolean=true
  hideConfirmPassword:boolean=true
  orgName:any
  // CAPTCHA temporarily disabled — keep for easy restore
  // captchaText: string = '';
  // captchaInput: string = '';
  // captchaError: boolean = false;
  constructor(private router: Router,private routert: ActivatedRoute,private apiService: requestsService,) {
    this.signUpForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      password: new FormControl('', [Validators.required,Validators.minLength(8),Validators.pattern('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,}')]),
      confirmPassword: new FormControl('', [Validators.required]),
      phone: new FormControl(''),
      acceptTerms: new FormControl(false)
    })
    this.routert.params.pipe(take(1)).subscribe(params => {
      console.log("params",params)
     this.orgName=params.organizationId
     console.log("organization name", this.orgName)
    });
    // CAPTCHA temporarily disabled
    // this.generateCaptcha();
  }

  // CAPTCHA temporarily disabled — keep for easy restore
  // generateCaptcha() {
  //   const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789';
  //   let result = '';
  //   for (let i = 0; i < 6; i++) {
  //     result += chars.charAt(Math.floor(Math.random() * chars.length));
  //   }
  //   this.captchaText = result;
  //   this.captchaInput = '';
  //   this.captchaError = false;
  // }

  // validateCaptcha(): boolean {
  //   if (this.captchaInput !== this.captchaText) {
  //     this.captchaError = true;
  //     this.generateCaptcha();
  //     return false;
  //   }
  //   this.captchaError = false;
  //   return true;
  // }

  ngOnInit(): void {
  }

  setTerms(val) {
    this.signUpForm.controls.acceptTerms.patchValue(val);
  }

  setPhone(val) {
    this.signUpForm.controls.phone.patchValue(val);
  }
  togglePasswordVisibility() {
    this.hidePassword = !this.hidePassword;
  }
  toggleConfirmPasswordVisibility(){
    this.hideConfirmPassword = !this.hideConfirmPassword;
  }
  signup(event) {
    event.preventDefault();
    if (this.signUpForm.invalid) {
      return;
    }
    // CAPTCHA temporarily disabled
    // if (!this.validateCaptcha()) {
    //   return;
    // }

    const params = this.signUpForm.value;

    if (!params.acceptTerms) {
      this.showError = 'Please accept the terms of service';
      return;
    }

    if (params.password !== params.confirmPassword) {
      this.showError = 'Password is not matching';
      return;
    }

    Auth.signUp({
      username: params.email,
      password: params.password,
      attributes: {
        name: params.firstName,
        middle_name: params.lastName,
        email: params.email,
        phone_number: params.phone
      }
    }).then(res => {
      this.showSuccess = true;
      var abv={
        user:params.email,
        password:params.password,
        org:this.orgName
      }
      setTimeout(() => this.router.navigate(['/verify'],{queryParams:abv, skipLocationChange: true }), 1000);
    }, err => {
      this.showError = err.message;
    });
  }

}

